const withoutParticipant = (map, pid) => {
    const { [pid]: _removed, ...rest } = map.byParticipant;
    return { byParticipant: rest };
};
export const planParticipantRemoval = (participantId, rows) => {
    const deletes = [];
    const patches = [];
    for (const { collection, item } of rows) {
        const { assignment } = item;
        const allocations = assignment.kind === "specific" ? assignment.allocations : [];
        const named = allocations.some((a) => a.participantId === participantId);
        // Sole allocatee: the row has no one left to complete it.
        if (named && allocations.every((a) => a.participantId === participantId)) {
            deletes.push({ collection, id: item.id });
            continue;
        }
        const patch = { collection, id: item.id };
        if (named) {
            patch.assignment = {
                kind: "specific",
                allocations: allocations.filter((a) => a.participantId !== participantId),
            };
        }
        if (item.completions.byParticipant[participantId] !== undefined) {
            patch.completions = withoutParticipant(item.completions, participantId);
        }
        const staging = "staging" in item ? item.staging : undefined;
        if (staging?.byParticipant[participantId] !== undefined) {
            patch.staging = withoutParticipant(staging, participantId);
        }
        if (patch.assignment !== undefined || patch.completions !== undefined || patch.staging !== undefined) {
            patches.push(patch);
        }
    }
    return { participantId, deletes, patches };
};
// Counts for the confirmation dialog: "Deletes N rows only Alice is on; M keep going."
export const previewParticipantRemoval = (participantId, rows) => {
    const plan = planParticipantRemoval(participantId, rows);
    return {
        deletes: plan.deletes.length,
        reassigned: plan.patches.filter((p) => p.assignment !== undefined).length,
    };
};
//# sourceMappingURL=removeParticipant.js.map